import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useHeaderContentStore } from '@/store';

/**
 * Lets a page add its own action to MainLayout's guest-only header-right slot,
 * beside the "End Session" button rather than replacing it (see MainLayout).
 * Pass `null` for pages with no action of their own. Mirrors
 * usePageHeaderContent, which covers the header's left slot.
 */
export const usePageHeaderAction = (content: ReactNode): void => {
  const setHeaderActionContent = useHeaderContentStore((s) => s.setHeaderActionContent);
  const clearHeaderActionContent = useHeaderContentStore((s) => s.clearHeaderActionContent);

  useEffect(() => {
    setHeaderActionContent(content);
  });

  useEffect(() => () => clearHeaderActionContent(), [clearHeaderActionContent]);
};

export default usePageHeaderAction;
